import { useState, useEffect } from 'react';
import { createSelectorHook, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Header from '../../../../components/Elements/header/header';
import StepsOfBuy from '../../../summary/navigatorBarSummary/stepsOfBuy/stepsOfBuy';
import CustomTittle from '../../../../components/Elements/customTittle/customTittle';
import CustomButtons from '../../../../components/Elements/Buttons/customButton';
import DetailOfCourse from '../../../../components/Elements/detailOfCourse/detailOfCourse';
import Modal from '../../../../components/Elements/modal/modal';
import ApiService from '../../../../services/ApiService';
import CourseDetail from '../../../coursDetail/courseDetail';
import EDSFooter from '../../../../components/EDSFooter';
import { setChName } from '../../../../reducers/reposReducers';
import { useDispatch } from 'react-redux';
import { API_URL, API_URL_getCourseWWWInfoPortal } from '../../../../config';

import './welcomePage.css';
 

const WelcomePage = (props) => {
    const apiService = ApiService.getInstance();
    const [login, setLogin] = useState();
    const [password, setPassword] = useState();
    const [keyLink, setKeyLink] = useState();
    const [departure, setDeprature] = useState("");
    const [response, setResponse] = useState();
    const stepsIndex = 0;
    const history = useHistory();
    var currentLocation = window.location;
    if(currentLocation.href&&currentLocation.href.includes("%20")){
        currentLocation.href =  currentLocation.href.replaceAll("%20", " ")
    }
    const courseHeadingNameDispatch = useDispatch();
    let [modalClass, showModal] = useState('modal hidden');
    let today = new Date();
    let day = today.getDate();
    let month = today.getMonth() + 1;
    let year = today.getFullYear();

    const [header, setHeader] = useState('/  PROCES ZAKUPU KURSU');
    if (month < 10) {
        month = '0' + month;
    }
    const [correctResponse, setCorrectResponse] = useState(true);
    const startDate = `${year}-${month}-${day}`;


    const dayList = [
        '',
        'Poniedziałek',
        'Wtorek',
        'Środa',
        'Czwartek',
        'Piątek',
        'Sobota',
        'Niedziela',
    ];
    const goToLogin = () => {
        let linkToPush;
  
        if (keyLink == undefined) {
            localStorage.setItem('keyURL', '');
            linkToPush = '/LoginBuy';
        } else {

            localStorage.setItem('keyURL', keyLink);
            if(departure == ""){
            linkToPush = '/LoginBuy/key=' + keyLink;}else{
                linkToPush = '/LoginBuy/key=' + keyLink + "&departure=" +departure; 
            }
        }
        
        history.push(linkToPush);
    };

    const goToRegister = () => {
        if(keyLink != undefined){
            courseHeadingNameDispatch(setChName(keyLink));
        }
        history.push('/Register');
    };

    function changeModal() {
        if (modalClass == 'modal hidden') {
            showModal('modal');
        } else {
            showModal('modal hidden');
        }
    }

    const stepsList = ['Logowanie', 'Kurs i formalności', 'Podsumowanie'];
    const [formData] = useState({
        courseHeadingName: keyLink, // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        attendanceStartDate: `${startDate}`,
        current_LocalizationsID: '0',
    });
    const [formDataCourse, setFormDataCourse] = useState({
        productsLevel2:3,
        // attendanceStartDate: `${startDate}`,
        current_LocalizationsID: '0',
        courseHeadingName: keyLink,
    });
    const splitLinkList = currentLocation.href.split('/');

    function reportWindowSize() {

    if(splitLinkList[4]!=undefined && splitLinkList[4].length > 0){
        if (window.innerWidth > 951) {
            setHeader('/  PROCES ZAKUPU KURSU');
        } else {
            setHeader('/  ZAKUP KURSU');
        }}else{
            setHeader('');
        }
    }

    useEffect(() => {
        reportWindowSize();
    }, []);
    
    window.onresize = reportWindowSize;
    function addDays(date, days) {

        date.setDate(date.getDate() + 1);
        return date;
      }
    useEffect(() => {
        let departureIn = "";
        for (let i = 0; i < splitLinkList.length; i++) {
            if (splitLinkList[i].includes('key')) {
                let linkToCheck = splitLinkList[i].split("=")
                if(splitLinkList[i].split("=")[1] != undefined){
                    if(splitLinkList[i].split("=")[1].includes("&")){
                        
                        formData.courseHeadingName = splitLinkList[i].split("=")[1].split("&")[0]
                        setKeyLink(splitLinkList[i].split("=")[1].split("&")[0]);
                    }else{
                        if(splitLinkList[i].includes("?")){
                            let linkToCheck = splitLinkList[i].split("=")[1].split("?")[0]
                            formData.courseHeadingName = linkToCheck;
                        setKeyLink(linkToCheck);
                        }else{
                        let linkToCheck = splitLinkList[i].split("=")[1]
                           
                        formData.courseHeadingName = linkToCheck;
                        setKeyLink(linkToCheck);}
                    }
                }
                if(splitLinkList[i].split("=")[2] != undefined && splitLinkList[i].split("?")[0].includes("&")){
                    
                    if(splitLinkList[i].split("=")[2].includes("?")){
                        departureIn= splitLinkList[i].split("=")[2].split("?")[0]
                        setDeprature(splitLinkList[i].split("=")[2].split("?")[0])
                    }else{
                        departureIn= splitLinkList[i].split("=")[2]
                        setDeprature(splitLinkList[i].split("=")[2])
                    }
                }
               
                
                
                
            }
        }
   
        if (formData.courseHeadingName != undefined && formData.courseHeadingName != '') {
            formDataCourse.courseHeadingName = formData.courseHeadingName
            let urlApi = `${API_URL_getCourseWWWInfoPortal}getCourseWWWInfoPortal`
           
           let jsonBody;
          
           if(departure == ""){
            if(departureIn == ""){
            jsonBody = formData}else{
                jsonBody = formDataCourse
               }
           }
           else{
            jsonBody = formDataCourse
           }

            fetch(
                `${urlApi}`,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: null,
                    },
                    body: JSON.stringify(jsonBody),
                }
            )
                .then((response) => {
               
                    return response.json();
                })
                .then((response) => {
                 
                    if(departure == ""){
                    localStorage.setItem('courseHeadingFull', JSON.stringify(response.body));
                    localStorage.setItem('danceStyle', response.body.courseDanceStyle);
                    localStorage.setItem('courseTime', response.body.courseTime);
                    localStorage.setItem('frequency', response.body.Frequency);
                    localStorage.setItem('courseLevel', response.body.courseLevel);
                    localStorage.setItem('courseAgeRanges', response.body.courseAgeRanges);
                    localStorage.setItem('localizationName', response.body.localizationName);
                    localStorage.setItem('instructorsList', response.body.instructorsList);
                    localStorage.setItem('localizationName', response.body.localizationName);
                    localStorage.setItem('eventDate', response.body.eventDate);
                    }else{
                        localStorage.setItem('campHeadingFull', JSON.stringify(response.body));
                    }
                });
        } else {
            setCorrectResponse(false);
            localStorage.removeItem('courseHeadingFull');
            localStorage.removeItem('danceStyle');
            localStorage.removeItem('courseTime');
            localStorage.removeItem('frequency');
            localStorage.removeItem('courseLevel');
            localStorage.removeItem('courseAgeRanges');
            localStorage.removeItem('localizationName');
            localStorage.removeItem('instructorsList');
            localStorage.removeItem('localizationName');
            localStorage.removeItem('eventDate');
        }
    }, [currentLocation.href]);

    const methodGetCourseWWWInfo = async () => {
        let key;
        for (let i = 0; i < splitLinkList.length; i++) {
            if (splitLinkList[i] == 'key' && splitLinkList[i + 1].length != 0) {
              
                setKeyLink(splitLinkList[i + 1]);
                formData.courseHeadingName = splitLinkList[i + 1];
            } else if (splitLinkList[i] == 'key' && splitLinkList[i + 1].length == 0) {
            }
        }

        if (formData.courseHeadingName != undefined) {
            await apiService.asyncApiPost('GetCourseWWWInfo', formData).then((response) => {
        
            });
        }

        return 'Finished methodGetCourseWWWInfo';
    };

    return (
        <>
            <div className={modalClass}>
                <Modal close={changeModal}></Modal>
            </div>
            <Header>{header}</Header>
            <div className="content">
            {splitLinkList[4]!=undefined && splitLinkList[4].length > 0?<StepsOfBuy choosen={stepsIndex} stepsList={stepsList}></StepsOfBuy>:""}
            <div className="rowSection">
                <div className="columnLogin" id="welcomePage_columnLogin">
                    <div className="columnLogin_wrapper">
                        <CustomTittle>Zaloguj się</CustomTittle>
                        <CustomButtons clickFunction={goToLogin} classButton="solid" size="big">
                            ZALOGUJ SIĘ
                        </CustomButtons>
                        <CustomButtons
                            clickFunction={goToRegister}
                            classButton="outline"
                            size="big"
                        >
                            ZAŁÓŻ KONTO
                        </CustomButtons>
                    </div>
                </div>
                <div className="columDetials">
                    {correctResponse ? (
                        <div className="columDetials_wrapper" id="welcomePAge_columnDetail">
                            <CustomTittle>Szczegóły zamówienia </CustomTittle>
                            <CourseDetail
                                tittle="login"
                                setHeader={setHeader}
                                header={header}
                            ></CourseDetail>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div> </div>
            {/* <div className="footerWrapper" style={{ marginTop: '50px' }}>
                <EDSFooter></EDSFooter>
            </div> */}
        </>
    );
};

export default WelcomePage;
